<template>
  <div id="warehouse-registered-payment-method-page" class="payment">
    <div class="text-center">
      <h1 class="payment-title">お支払い方法のご登録ありがとうございます。</h1>
    </div>
    <div class="payment-content">
      <div class="m-b-xl">
        お手続きありがとうございます。<br>
        倉庫をご利用いただく準備が整いました。
      </div>
      <div class="m-b-xl">
        月毎のご利用料は、ご登録頂いたお支払い方法にて決済させていただきます。
      </div>
      <div class="m-b-xl">
        尚、倉庫が利用可能となるまで、お時間を頂く場合があります。<br>
        倉庫管理画面にて 「利用中の倉庫」 に表示されない場合は、しばらくたってからご確認いただくようお願いいたします。
      </div>
      <div class="box-link-to-warehouse m-b-lg">
        <router-link to="/Warehouses" class="link-to-warehouse">倉庫管理はこちら</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      sessionId: null
    }
  },
  created () {
    this.sessionId = this.$route.query.session_id
    if (!this.sessionId) {
      this.$router.push('/not-found')
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouses.show_registered_payment_method_page,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouses/RegisteredPaymentMethod.vue